import {Text} from '@mantine/core';
import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {sharedStyles} from './McpModalStyles';

interface McpAuthPromptProps {
  authRedirectUrl: string;
  onAuthComplete: () => void;
}

export default function McpAuthPrompt(props: McpAuthPromptProps): JSX.Element {
  const {authRedirectUrl, onAuthComplete} = props;

  const handleAuthClick = (): void => {
    const authWindow = window.open(authRedirectUrl, '_blank');

    // Poll to check if the window is closed, then notify parent
    if (authWindow) {
      const pollInterval = setInterval(() => {
        if (authWindow.closed) {
          clearInterval(pollInterval);
          onAuthComplete();
        }
      }, 500);
    }
  };

  return (
    <div className={css(sharedStyles.loadingState)}>
      <Text>Authentication required to view tools.</Text>
      <button type="button" onClick={handleAuthClick} className={css(styles.authButton)}>
        Authenticate
      </button>
    </div>
  );
}

const styles = StyleSheet.create({
  authButton: {
    marginTop: 12,
    padding: '8px 16px',
    fontSize: 13,
    fontWeight: 500,
    cursor: 'pointer',
    border: 'none',
    borderRadius: 4,
    backgroundColor: '#1976d2',
    color: 'white',
    ':hover': {
      backgroundColor: '#1565c0',
    },
  },
});
